import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, Typography, useTheme } from "@mui/material";
import { useRecommendationDetails } from "../../RecommendationDetailsProvider";

export const PolicySection = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { fundDetails } = useRecommendationDetails();

  if (!fundDetails) return null;

  return (
    <Box display="flex" flexDirection="column" gap={3} mt={2}>
      <Typography variant="body3">
        {t("recommender.detailsModal.ideaTitle")}
      </Typography>
      <Typography variant="body3" color="textSecondary">
        {fundDetails.investmentPolicy}
      </Typography>
      <Divider sx={{ margin: theme.spacing(4, 0, 0) }} />
    </Box>
  );
};
